__turbopack_context__.v({
  "captionFlexItems": "Carousel-module__-q5euG__captionFlexItems",
  "carousal-img-container": "Carousel-module__-q5euG__carousal-img-container",
  "circle-blur-btn": "Carousel-module__-q5euG__circle-blur-btn",
  "content": "Carousel-module__-q5euG__content",
  "element-img": "Carousel-module__-q5euG__element-img",
  "embla": "Carousel-module__-q5euG__embla",
  "embla__container": "Carousel-module__-q5euG__embla__container",
  "embla__next": "Carousel-module__-q5euG__embla__next",
  "embla__prev": "Carousel-module__-q5euG__embla__prev",
  "embla__slide": "Carousel-module__-q5euG__embla__slide",
  "root": "Carousel-module__-q5euG__root",
  "shimmer": "Carousel-module__-q5euG__shimmer",
  "video-container": "Carousel-module__-q5euG__video-container",
});
